module.exports = {
  "zones": {
    "Pacific/Apia": ["z", {
      "wallclock": 1325203200000,
      "format": "+13/+14",
      "abbrev": "+14",
      "offset": 46800000,
      "posix": 1325239200000,
      "save": 3600000,
      "rules": "WS"
    }, {
      "wallclock": -631152000000,
      "format": "-11/-10",
      "abbrev": "-11",
      "offset": -39600000,
      "posix": -631110600000,
      "save": 0,
      "rules": "WS"
    }, {
      "wallclock": -1861920000000,
      "format": "-1130",
      "abbrev": "-1130",
      "offset": -41400000,
      "posix": -1861878784000,
      "save": 0
    }, {
      "wallclock": -2445379200000,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -41216000,
      "posix": -2445424384000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 45184000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "WS": [{
      "from": 2012,
      "to": 1.7976931348623157e+308,
      "month": 3,
      "day": [0, 1],
      "time": 240,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2012,
      "to": 1.7976931348623157e+308,
      "month": 8,
      "day": [0, -30],
      "time": 180,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2011,
      "to": 2011,
      "month": 3,
      "day": [6, 1],
      "time": 240,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 2011,
      "to": 2011,
      "month": 8,
      "day": [6, -30],
      "time": 180,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 2010,
      "to": 2010,
      "month": 8,
      "day": [0, -30],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }]
  }
};